import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["imageUrl", "link", "body", "title", "topic", "lazyLoad"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import classNames from 'classnames';
import { Link } from '@scentregroup/shared/link';
import Paragraph from "@scentregroup/ui/components/paragraph";
import Container from "@scentregroup/ui/components/container";
import Article from '../article';
import ResponsiveImage from '../responsive-image';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FullWidth = _ref => {
  let {
      imageUrl,
      link,
      body,
      title,
      topic,
      lazyLoad
    } = _ref,
    articleProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(Container, {
    centred: true,
    className: classNames(style.FullWidth),
    type: "large",
    "data-id": "full-width_index_FullWidth_Container",
    children: [imageUrl && /*#__PURE__*/_jsx(Link, {
      to: link,
      "data-id": "full-width_index_FullWidth_Link",
      children: /*#__PURE__*/_jsx(ResponsiveImage, {
        lazyLoad: lazyLoad,
        className: style.image,
        desktopImageUrl: imageUrl,
        mobileImageUrl: imageUrl,
        mobileRatio: "standard",
        desktopRatio: "standard",
        numberOfItems: 1,
        alt: articleProps.heading,
        "data-id": "full-width_index_FullWidth_Link_ResponsiveImage"
      })
    }), /*#__PURE__*/_jsx(Article, _objectSpread(_objectSpread({
      className: style.Article,
      superheading: topic,
      link: link,
      heading: title
    }, articleProps), {}, {
      "data-id": "full-width_index_FullWidth_Container_Article",
      children: /*#__PURE__*/_jsx(Paragraph, {
        "data-id": "full-width_index_FullWidth_Article_Paragraph",
        children: body
      })
    }))]
  });
};
FullWidth.defaultProps = {
  lazyLoad: true
};
export default FullWidth;